import React from 'react'
import {ToastContainer} from "react-toastify"
export const Toast = () => {
    return (
        <ToastContainer toastClassName="toast" position="bottom-center"
        />
    )}